<template>
  <div>
    <div class="mx-2">
      <v-layout row align-baseline justify-center class="pl-3 pr-2">
        <v-flex>
          <v-textarea label="Message" rows="3" v-model="message"></v-textarea>
        </v-flex>
        <v-flex xs1>
          <v-icon style="cursor:pointer;" @click="sendMessage">send</v-icon>
        </v-flex>
      </v-layout>
      <div
        v-for="(com, id) in sortedComments"
        :key="id"
        :class="{
          'ml-5': com.owner === 'user',
          'mr-5': com.owner === 'hil',
          'mr-2': true,
          'pb-2': true
        }"
      >
        <!-- Prettier rule: https://prettier.io/blog/2018/11/07/1.15.0.html#whitespace-sensitive-formatting -->
        <!-- display: inline -->
        <div
          class="message-content px-2 py-2 mt-3"
          :style="`border: 2px solid ${color(com)};`"
          >{{ com.comment }}
        </div>
        <div class="message-infos d-flex justify-content-between">
          <div>{{ com.name || "???" }}</div>
          <div>{{ com.date | fullDate }}</div>
        </div>
      </div>
    </div>
    <v-snackbar v-model="showError">
      Une erreur a eu lieu
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { fetchHil } from "../../utils";
export default {
  props: ["proposal", "active"],
  data() {
    return {
      message: "",
      showError: false
    };
  },
  timers: {
    markNotifsAsRead: { time: 2000, autostart: true, repeat: true }
  },
  methods: {
    async sendMessage() {
      if (this.message == null) {
        return;
      }
      this.$emit("pushComment", {
        comment: this.message,
        name: this.$store.state.user.id,
        date: new Date(),
        owner: "user"
      });
      this.message = "";
    },
    color(comm) {
      switch (comm.owner) {
        case "hil":
          return "#60A694";
        case "user":
          return "#FF7C5D";
        default:
          return "#DDD";
      }
    },
    markNotifsAsRead() {
      if (this.active) {
        this.$store.dispatch("markNotifsAsRead", {
          projectId: this.proposal.idBuy,
          estateId: this.proposal.idSell
        });
      }
    }
  },
  computed: {
    sortedComments() {
      const comms = [...(this.proposal.comments || [])];
      comms.sort((a, b) => {
        return moment(b.date).isAfter(a.date) ? 1 : -1;
      });
      return comms;
    }
  }
};
</script>

<style>
.message-content {
  font-size: 13px;
  overflow-wrap: break-word;
}
.message-infos {
  padding-left: 8px;
  font-size: 10px;
  font-style: italic;
}
</style>
